
export type ApiV1DashboardSummaryGet200ResponseSummaryRecentActivitiesItem = { [key: string]: unknown };
